import React, { useState, useEffect } from 'react';
import api from '../../../api';

import styles from './PushNotificationsList.module.css';

const PushNotificationsList = props => {
  const {
    pushNotificationDetails,
    setPushNotificationDetails,
    isListFetching,
    setIsListFetching,
    pushNotifications,
    setPushNotifications
  } = props;

  const [isAppendFetching, setIsAppendFetching] = useState(false);
  const [totalPushNotifications, setTotalPushNotifications] = useState(0);
  const [totalPages, setTotalPages] = useState(null);
  const [page, setPage] = useState(0);

  const formatDate = date => {
    if (!date) return null;

    const monthShortNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    const convertDate = new Date(date);

    const day = convertDate.getDate();
    const monthIndex = convertDate.getMonth() + 1;
    const year = convertDate.getFullYear();

    // Today
    const today = new Date();

    // Yesterday
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    if (
      day === today.getDate() &&
      monthIndex === today.getMonth() + 1 &&
      year === today.getFullYear()
    ) {
      return `${convertDate.getHours()}:${
        convertDate.getMinutes() < 10 ? '0' : ''
      }${convertDate.getMinutes()}, Today`;
    }

    if (
      day === yesterday.getDate() &&
      monthIndex === yesterday.getMonth() + 1 &&
      year === yesterday.getFullYear()
    ) {
      return 'Yesterday';
    }

    if (year === today.getFullYear())
      return `${day} ${monthShortNames[monthIndex - 1]}`;
    return `${day} ${monthShortNames[monthIndex - 1]}, ${year}`;
  };

  const fetchOptionsExecute = (newPage, empty) => {
    const getAllPushNotifications = async () => {
      if (newPage) {
        setIsAppendFetching(true);
      } else {
        setIsListFetching(true);
      }

      if (!totalPages || newPage < totalPages) {
        const pushNotificationsData = await api().getAllPushNotifications(
          newPage || 0,
          10
        );
        setTotalPushNotifications(pushNotificationsData.json.meta.total);
        setTotalPages(Math.ceil(pushNotificationsData.json.meta.total / 10));

        if (empty) {
          setPushNotifications(pushNotificationsData.json.data);
        }
        if (!empty) {
          setPushNotifications([
            ...pushNotifications,
            ...pushNotificationsData.json.data
          ]);
        }
      }

      if (newPage) {
        setIsAppendFetching(false);
      } else {
        setIsListFetching(false);
      }
    };

    getAllPushNotifications();
  };

  useEffect(() => {
    fetchOptionsExecute();
  }, []);

  const listOptionsDivScroll = async event => {
    const elem = event.currentTarget;
    if (
      elem.scrollHeight - elem.scrollTop - 5 <= elem.offsetHeight &&
      !isListFetching
    ) {
      setPage(page + 1);
      fetchOptionsExecute(page + 1);
    }
  };

  if (isListFetching) {
    return (
      <div
        className={`${styles.notificationsListContainter} ${
          styles.whiteContainer
        }`}
      >
        <div
          className={`${styles.pageContentListPlaceholder} loader-container`}
        />
      </div>
    );
  }

  return (
    <div
      className={`${styles.notificationsListContainter} ${
        styles.whiteContainer
      }`}
    >
      <div className={styles.title}>
        {totalPushNotifications} Push Notifications
      </div>
      <div
        className={styles.notificationsContainer}
        onScroll={listOptionsDivScroll}
      >
        {pushNotifications.map((pushNotification, index) => (
          <div
            className={
              pushNotificationDetails &&
              pushNotificationDetails.id === pushNotification.id
                ? `${styles.notificationItem} ${
                    styles.notificationItemSelected
                  }`
                : styles.notificationItem
            }
            key={`push-notification-list-item-${index.toString()}`}
            role="presentation"
            onClick={() => setPushNotificationDetails(pushNotification)}
          >
            <div className={styles.label}>
              <span className={styles.name}>
                {pushNotification &&
                  pushNotification.attributes &&
                  pushNotification.attributes.title}
              </span>
              {pushNotification.attributes &&
              pushNotification.attributes.createdAt ? (
                <div className={styles.date}>
                  {formatDate(pushNotification.attributes.createdAt)}
                </div>
              ) : null}
            </div>
            <div className={styles.filterDetails}>
              <div className={styles.filterType}>
                {pushNotification.attributes &&
                pushNotification.attributes.filter_string === '[]'
                  ? 'All users'
                  : 'Custom filter'}
              </div>
              {pushNotification.attributes &&
              pushNotification.attributes.count ? (
                <div className={styles.count}>
                  {pushNotification.attributes.count} users
                </div>
              ) : null}
            </div>
          </div>
        ))}
        {isAppendFetching ? (
          <div className={styles.loadingPlaceholder}>Loading</div>
        ) : null}
      </div>
    </div>
  );
};

export default PushNotificationsList;
